export default __webpack_public_path__ + "ymca-building-purple.svg";